import { Box } from '@packages/shared/src/components/Box/Box';
import { Image } from '@packages/shared/src/components/Image/Image';
import { getFragmentData, type FragmentType } from '@packages/gql/generated/shopping';
import { VariationIconFragmentFragmentDoc } from '@packages/gql/generated/shopping/VariationIconFragmentFragmentDoc';
import { useResponsiveAkamaiTemplate } from '../../hooks/useResponsiveAkamaiTemplate/useResponsiveAkamaiTemplate';

const IMAGESIZEBUTTON = 24;

/* GraphQL */ `
  fragment VariationIconFragment on ProductDimensionValue {
    rgb
    image
    displayText
  }
`;

export type VariationIconProps = {
  data: FragmentType<typeof VariationIconFragmentFragmentDoc>;
  /**
   * the size of the image Tile
   */
  imageSize: 'BUTTON' | 'DIALOG';
};

/**
 * The `VariationIcon` conponent is used to display an image for the selected dimension,
 * either for the `VariationRow` inside as part of the dialog or in the `SelectionDimension` as a button
 * */
export const VariationIcon = ({ data, imageSize }: VariationIconProps) => {
  const { rgb, image, displayText } = getFragmentData(VariationIconFragmentFragmentDoc, data);

  const { templateName, imageDimensions } = useResponsiveAkamaiTemplate('variationSelect');
  const IMAGESIZE = imageSize === 'BUTTON' ? IMAGESIZEBUTTON : imageDimensions.height;

  return (
    <Box
      sx={{
        borderRadius: '50%',
        overflow: 'hidden',
        height: `${IMAGESIZE}px`,
        width: `${IMAGESIZE}px`,
        flex: `0 0 ${IMAGESIZE}px`,
        backgroundColor: rgb ? `#${rgb}` : undefined,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'grey.main',
      }}
    >
      {image && (
        <Image
          src={imageSize === 'DIALOG' ? `${image}?${templateName}` : image}
          alt={displayText || ''}
          width={IMAGESIZE}
          height={IMAGESIZE}
        />
      )}
    </Box>
  );
};
